"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavDrawer = void 0;
const tslib_1 = require("tslib");
const icon_1 = require("../../components/icon");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const page_1 = require("../../page/page");
const services_1 = require("../../services");
const CSS = {
    container: 'c-Nav',
    isVisible: 'c-Nav--isVisible',
    content: 'c-Nav__Content',
    logo: 'c-Nav__Logo',
    username: 'c-Nav__UserName',
    navText: 'c-Nav__NavText',
    logout: 'c-Nav__Logout',
    entry: 'c-Nav__Entry',
    entryCurrent: 'c-Nav__Entry--Current',
    bullet: 'c-Nav__Bullet'
};
const Style = {
    [CSS.container]: {
        'justify-content': 'space-between',
        'overflow-x': 'hidden'
    },
    [CSS.isVisible]: {
        transform: 'translateX(0)'
    },
    [CSS.content]: {
        display: 'flex',
        'flex-direction': 'column'
    },
    [CSS.logo]: {
        'margin-top': theme_1.DefaultTheme.space(4),
        width: '100%',
        height: '50px'
    },
    [CSS.username]: {
        'text-align': 'center',
        margin: `${theme_1.DefaultTheme.space(4)} 0`,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'
    },
    [CSS.navText]: {
        'text-align': 'left',
        margin: `${theme_1.DefaultTheme.space(1)}`,
        overflow: 'visible',
        'white-space': 'wrap'
    },
    [CSS.logout]: {
        display: 'inline-block',
        padding: `0 0 ${theme_1.DefaultTheme.space(4)} ${theme_1.DefaultTheme.space(4)}`
    },
    [CSS.entry]: {
        height: theme_1.DefaultTheme.space(18),
        display: 'flex',
        'align-items': 'center',
        color: '#757575',
        'font-weight': 700,
        cursor: 'pointer',
        'text-decoration': 'none',
        '&:hover': {
            'background-color': theme_1.DefaultTheme.background.lightGrey,
            color: theme_1.DefaultTheme.color.accent
        }
    },
    [CSS.entryCurrent]: {
        cursor: 'default',
        color: theme_1.DefaultTheme.color.accent
    },
    [CSS.bullet]: {
        width: theme_1.DefaultTheme.space(18),
        'text-align': 'center'
    }
};
(0, theme_1.addStyles)(Style);
exports.NavDrawer = {
    view(ctrl) {
        const entryNodes = [];
        for (const entry of ctrl.entries) {
            entryNodes.push(exports.NavDrawer.viewEntry(ctrl, entry));
        }
        const visibleClass = ctrl.visible ? CSS.isVisible : '';
        return (0, mithril_1.m)('div', {
            className: `${CSS.container} mdl-layout__drawer ${visibleClass}`,
            oncreate: (vnode) => services_1.Services.FocusAway.from(vnode.dom, () => ctrl.setVisible(false))
        }, [
            (0, mithril_1.m)('div', { className: CSS.content }, [
                (0, mithril_1.m)('img', { className: CSS.logo, src: (0, theme_1.assetPath)('/images/ike_logo.svg') }),
                (0, mithril_1.m)('span', { className: CSS.username }, ctrl.username),
                ...entryNodes
            ]),
            (0, mithril_1.m)('div', { className: CSS.content }, [
                (0, mithril_1.m)('a', { className: CSS.logout, href: services_1.Services.Route.getRouteURL(page_1.IkePageName.logout) }, (0, i18n_1.Translate)(i18n_1.T.LOGOUT))
            ])
        ]);
    },
    viewEntry(ctrl, entry) {
        if (entry.current) {
            return (0, mithril_1.m)('a', {
                className: `${CSS.entry} ${CSS.entryCurrent}`
            }, [
                icon_1.Icon.view(entry.icon, { className: CSS.bullet }),
                (0, mithril_1.m)('span', { className: CSS.navText }, (0, i18n_1.Translate)(entry.title))
            ]);
        }
        return (0, mithril_1.m)('a', {
            className: CSS.entry,
            href: services_1.Services.Route.getRouteURL(entry.name),
            target: entry.type === 'external' ? '_blank' : undefined,
            onclick: entry.type === 'internal'
                ? (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    yield services_1.Services.Window.confirmPageChange(e, services_1.Services.Route.getRouteURL(entry.name));
                })
                : undefined
        }, [
            icon_1.Icon.view(entry.icon, { className: CSS.bullet }),
            (0, mithril_1.m)('span', { className: CSS.navText }, (0, i18n_1.Translate)(entry.title))
        ]);
    }
};
//# sourceMappingURL=nav.drawer.js.map